import { BentoBrand } from "schemas/dashboard";

import { titleCase } from "./string";

export const UNCATEGORIZED = "Uncategorized";

export const getCategoryName = (brand: BentoBrand) => {
  if (brand?.mainCategoryNames && brand?.mainCategoryNames.length > 0) {
    return titleCase(brand.mainCategoryNames?.join(", "));
  } else if (
    brand?.secondaryCategoryNames &&
    brand?.secondaryCategoryNames.length > 0
  ) {
    return titleCase(brand?.secondaryCategoryNames?.join(", "));
  } else {
    return UNCATEGORIZED;
  }
};
